module.exports = __webpack_public_path__ + "img/ic_dinghuohui@2x.4182bad7.png";